var _path, _path2, _g, _path3, _g2, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForexLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 96,
    viewBox: "0 0 100 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8221 6.88V8.368H28.1021V11.648H31.7821V13.136H28.1021V18H26.2781V6.88H32.8221ZM39.5845 18.112C38.5498 18.112 37.5952 17.872 36.7205 17.392C35.8565 16.9013 35.1685 16.224 34.6565 15.36C34.1552 14.4853 33.9045 13.504 33.9045 12.416C33.9045 11.328 34.1552 10.352 34.6565 9.488C35.1685 8.624 35.8565 7.952 36.7205 7.472C37.5952 6.98133 38.5498 6.736 39.5845 6.736C40.6298 6.736 41.5845 6.98133 42.4485 7.472C43.3232 7.952 44.0112 8.624 44.5125 9.488C45.0138 10.352 45.2645 11.328 45.2645 12.416C45.2645 13.504 45.0138 14.4853 44.5125 15.36C44.0112 16.224 43.3232 16.9013 42.4485 17.392C41.5845 17.872 40.6298 18.112 39.5845 18.112ZM39.5845 16.528C40.3205 16.528 40.9765 16.3627 41.5525 16.032C42.1285 15.6907 42.5765 15.2107 42.8965 14.592C43.2272 13.9627 43.3925 13.2373 43.3925 12.416C43.3925 11.5947 43.2272 10.8747 42.8965 10.256C42.5765 9.63733 42.1285 9.16267 41.5525 8.832C40.9765 8.50133 40.3205 8.336 39.5845 8.336C38.8485 8.336 38.1925 8.50133 37.6165 8.832C37.0405 9.16267 36.5872 9.63733 36.2565 10.256C35.9365 10.8747 35.7765 11.5947 35.7765 12.416C35.7765 13.2373 35.9365 13.9627 36.2565 14.592C36.5872 15.2107 37.0405 15.6907 37.6165 16.032C38.1925 16.3627 38.8485 16.528 39.5845 16.528ZM52.8354 18L50.2754 13.552H48.8834V18H47.0594V6.88H50.8994C51.7527 6.88 52.4727 7.02933 53.0594 7.328C53.6567 7.62667 54.0994 8.02667 54.3874 8.528C54.686 9.02933 54.8354 9.58933 54.8354 10.208C54.8354 10.9333 54.622 11.5947 54.1954 12.192C53.7794 12.7787 53.134 13.1787 52.2594 13.392L55.0114 18H52.8354ZM48.8834 12.096H50.8994C51.582 12.096 52.094 11.9253 52.4354 11.584C52.7874 11.2427 52.9634 10.784 52.9634 10.208C52.9634 9.632 52.7927 9.184 52.4514 8.864C52.11 8.53333 51.5927 8.368 50.8994 8.368H48.8834V12.096ZM58.9928 8.352V11.616H62.8328V13.104H58.9928V16.512H63.3128V18H57.1688V6.864H63.3128V8.352H58.9928ZM70.6634 12.448L74.1194 18H72.0714L69.5594 13.968L67.2074 18H65.1754L68.6314 12.448L65.1594 6.88H67.2074L69.7354 10.944L72.1034 6.88H74.1354L70.6634 12.448Z",
    fill: "url(#paint0_linear_208_22397)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_22397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 100,
    height: 90
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.41748H99.9992V96.0001H0V6.41748Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_22397)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.869 95.9923C53.942 95.9923 46.0367 95.9923 38.1302 95.9923L33.4235 88.515C36.3061 79.8659 33.6489 70.3619 26.7576 64.4387L24.3476 53.9884C16.5098 58.6505 6.55497 57.5015 0 51.1949L28.0862 43.1546L43.1987 88.515C47.7258 88.515 52.2529 88.515 56.7788 88.515L71.8913 43.1546L99.9992 51.1949C93.4454 57.5015 83.4677 58.6505 75.6529 53.9884L73.2428 64.4387C66.3515 70.3619 63.6931 79.8659 66.554 88.515L61.869 95.9923ZM11.3292 37.7715C37.1175 37.7715 62.8829 37.7715 88.6712 37.7715L97.0491 6.46631L82.2524 30.5426C60.7212 30.5426 39.2346 30.5426 17.748 30.5426L2.92846 6.46631L11.3292 37.7715Z",
    fill: "#057D67"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_208_22397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 6,
    width: 50,
    height: 83
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3018 6.41748H100V88.5747H50.3018V6.41748Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_208_22397)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1585 37.7715H50.4287V88.515H56.8028L67.9971 54.8661C66.1042 59.3486 61.2178 61.9382 56.3073 60.8351L68.5372 53.2903L71.9153 43.1546L100 51.1949L75.1585 37.7715ZM77.5239 26.3977L50.4287 27.232V30.5426H82.2536L97.0502 6.46631L77.5239 26.3977Z",
    fill: "#0BC8A6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2485 60.9474C58.9874 61.1499 57.6359 61.1282 56.3073 60.8123L60.316 58.3577C57.6142 49.1455 58.4473 42.2988 62.8165 37.75H50.4287V88.4922H53.6043L60.2485 60.9474Z",
    fill: "#07F2C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_22397",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07F2C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForexLogo);
export default __webpack_public_path__ + "static/media/ForexLogo.b3996b0f995cf2aa63b98c52fa5ca69c.svg";
export { ForwardRef as ReactComponent };